import { LimitRow } from '@widgets/card/limitRow/limitRow';
import { BaseInput } from '@shared/widgets';

interface CardNewLimitRowProps {
  limitRowLabel: string;
  currentAmount: number;
  limitAmount: number;
  limitNumber: number;
  currentNumber: number;
  symbol?: string;
  firstInputLabel: string;
  firstInputValue: string | number;
  firstInputOnChange: (value: string) => void;
  firstInputLimitValue?: number;
  secondInputLabel: string;
  secondInputValue: string | number;
  secondInputOnChange: (value: string) => void;
  secondInputLimitValue?: number;
}

export const CardNewLimitRow = (props: CardNewLimitRowProps) => {
  const validPattern = /^\d*\.?\d{0,2}$/;
  return (
    <div className='mb-5 px-5 w-72 max-w-full'>
      <LimitRow
        label={props.limitRowLabel}
        currentAmount={props.currentAmount}
        limitAmount={props.limitAmount}
        limitNumber={props.limitNumber}
        currentNumber={props.currentNumber}
        symbol={props.symbol}
      />

      <div className='mt-3'>
        <BaseInput
          type='number'
          placeholder={props.firstInputLabel}
          onChange={(value) => {
            if (validPattern.test(value)) {
              props.firstInputOnChange(value);
            }
          }}
          value={props.firstInputValue as string}
        />
      </div>
      <div className='mt-3'>
        <BaseInput type='number' placeholder={props.secondInputLabel} onChange={props.secondInputOnChange} value={props.secondInputValue as string} />
      </div>
    </div>
  );
};
